import { group, control } from '@reactables/forms';

export const basicCoverage = group({
  controls: {
    coverage: control([1000000, 'required']),
    confirmed: control([false]),
  },
});
